window.CH_BAD_WORDS = {
  "substring": [
    "2g1c",
    "acrotomophilia",
    "anilingus",
    "apeshit",
    "arsehole",
    "asshole",
    "assmunch",
    "autoerotic",
    "babeland",
    "bangbros",
    "bangbus",
    "bareback",
    "barenaked",
    "bastard",
    "bastardo",
    "bastinado",
    "bdsm",
    "beaner",
    "beaners",
    "beastiality",
    "bestiality",
    "bimbos",
    "birdlock",
    "bitch",
    "bitches",
    "blowjob",
    "blumpkin",
    "bollocks",
    "bondage",
    "boner",
    "boobs",
    "bukkake",
    "bulldyke",
    "bullshit",
    "bunghole",
    "busty",
    "buttcheeks",
    "butthole",
    "camgirl",
    "camslut",
    "camwhore",
    "carpetmuncher",
    "cialis",
    "circlejerk",
    "clit",
    "clitoris",
    "clusterfuck",
    "cocks",
    "coons",
    "coprolagnia",
    "coprophilia",
    "cornhole",
    "creampie",
    "cumshot",
    "cumshots",
    "cunnilingus",
    "cunt",
    "darkie",
    "daterape",
    "deepthroat",
    "dendrophilia",
    "dildo",
    "dingleberries",
    "dingleberry",
    "doggiestyle",
    "doggystyle",
    "dolcett",
    "domination",
    "dominatrix",
    "dommes",
    "dvda",
    "ecchi",
    "ejaculation",
    "erotic",
    "erotism",
    "escort",
    "eunuch",
    "faggot",
    "fecal",
    "felch",
    "fellatio",
    "feltch",
    "femdom",
    "figging",
    "fingerbang",
    "fingering",
    "fisting",
    "footjob",
    "frotting",
    "fuck",
    "fuckin",
    "fucking",
    "fucktards",
    "fudgepacker",
    "futanari",
    "g-spot",
    "gangbang",
    "genitals",
    "goatcx",
    "goatse",
    "gokkun",
    "goodpoop",
    "goregasm",
    "grope",
    "guro",
    "handjob",
    "hardcore",
    "hentai",
    "homoerotic",
    "honkey",
    "hooker",
    "horny",
    "humping",
    "incest",
    "intercourse",
    "jailbait",
    "jigaboo",
    "jiggaboo",
    "jiggerboo",
    "jizz",
    "juggs",
    "kike",
    "kinbaku",
    "kinkster",
    "kinky",
    "knobbing",
    "livesex",
    "lolita",
    "lovemaking",
    "masturbate",
    "masturbating",
    "masturbation",
    "milf",
    "motherfucker",
    "muffdiving",
    "nambla",
    "nawashi",
    "neonazi",
    "nigga",
    "nigger",
    "nimphomania",
    "nipple",
    "nipples",
    "nsfw",
    "nudity",
    "nutten",
    "nympho",
    "nymphomania",
    "octopussy",
    "omorashi",
    "orgasm",
    "orgy",
    "paedophile",
    "paki",
    "panties",
    "panty",
    "pedobear",
    "pedophile",
    "pegging",
    "penis",
    "pikey",
    "pissing",
    "pisspig",
    "playboy",
    "ponyplay",
    "poof",
    "poontang",
    "poopchute",
    "porn",
    "porno",
    "pornography",
    "pthc",
    "pubes",
    "punany",
    "pussy",
    "queaf",
    "queef",
    "quim",
    "raghead",
    "rape",
    "raping",
    "rapist",
    "rectum",
    "rimjob",
    "rimming",
    "sadism",
    "santorum",
    "scat",
    "schlong",
    "scissoring",
    "semen",
    "sexcam",
    "sexo",
    "sexual",
    "sexuality",
    "sexually",
    "sexy",
    "shemale",
    "shibari",
    "shit",
    "shitblimp",
    "shitty",
    "shota",
    "shrimping",
    "skeet",
    "slanteye",
    "slut",
    "snatch",
    "snowballing",
    "sodomize",
    "sodomy",
    "spastic",
    "splooge",
    "spooge",
    "spunk",
    "strapon",
    "strappado",
    "suck",
    "sucks",
    "swastika",
    "swinger",
    "threesome",
    "throating",
    "thumbzilla",
    "tits",
    "titties",
    "titty",
    "topless",
    "tosser",
    "towelhead",
    "tranny",
    "tribadism",
    "tubgirl",
    "tushy",
    "twat",
    "twink",
    "twinkie",
    "undressing",
    "upskirt",
    "urophilia",
    "vagina",
    "viagra",
    "vibrator",
    "vorarephilia",
    "voyeur",
    "voyeurweb",
    "voyuer",
    "vulva",
    "wank",
    "wetback",
    "whore",
    "worldsex",
    "yaoi",
    "yiffy",
    "zoophilia"
  ],
  "exact": [
    "anal",
    "anus",
    "ass",
    "cumming",
    "poon",
    "boob",
    "butt",
    "cock",
    "coon",
    "cum",
    "dick",
    "fag",
    "mong",
    "negro",
    "nude",
    "sex",
    "smut",
    "spic",
    "tit",
    "mckenna"
  ],
  "allow": [
    "dick",
    "hooker",
    "poon",
    "semenko",
    "semenov"
  ]
};
